import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'

export const INSTRUMENT_TYPES = [
  'fxfwd',
  'bond',
  'equity',
  'index',
  'fund',
  'diver-otc',
  'equity-otc',
  'aswap',
  'autocall-standard',
  'autocall-consolation',
  'autocall-phoenix',
  'digital',
  'vanilla-spread',
  'vanilla-structured',
  'range-accrual',
  'supertracker',
  'other',
  'vanilla',
  'vanilla-digital',
] as const

export type InstrumentType = (typeof INSTRUMENT_TYPES)[number]

const INSTRUMENT_TYPE_LABELS: Record<InstrumentType, string> = {
  bond: 'Bond',
  aswap: 'Aswap',
  digital: 'Digital',
  equity: 'Equity',
  fund: 'Fund',
  fxfwd: 'FxFwd',
  index: 'Index',
  'diver-otc': 'Diver OTC',
  'equity-otc': 'Equity OTC',
  'autocall-standard': 'Autocall Standard',
  'autocall-consolation': 'Autocall Consolation',
  'autocall-phoenix': 'Phoenix Non-Memory',
  'vanilla-spread': 'Call / Put Spread',
  'vanilla-structured': 'Call / Put Structured',
  'range-accrual': 'Range Accrual',
  supertracker: 'Supertracker',
  vanilla: 'Vanilla',
  'vanilla-digital': 'Vanilla Digital',
  other: 'Other',
}

export const INSTRUMENT_TYPE_OPTIONS = sortAlphabeticallyByKey(
  INSTRUMENT_TYPES.map((i) => ({
    label: INSTRUMENT_TYPE_LABELS[i],
    value: i,
  })),
  'label',
)
